<template>
  <div>
    <v-row no-gutters style="margin-bottom: 16px">
      <Header4>Eigene Felder zur Person</Header4>
    </v-row>
    <v-row v-if="!fetchError" no-gutters justify="center">
      <CustomAttributesList
        ref="personalList"
        attributable-type="PersonalRecord"
        @fetchError="handleFetchError"
        @moved="handleMoved"
      />
    </v-row>
    <ErrorAlert
      :width="450"
      v-else
      title="Fehler beim Laden"
      :message="fetchError"
    />
    <v-row no-gutters style="margin-top: 16px">
      <CustomAttributesCreate
        attributable_type="PersonalRecord"
        @created="handleCreation"
      />
    </v-row>
    <v-row no-gutters style="margin-top: 16px; margin-bottom: 16px">
      <Header4>Eigene Felder zu Mitgliedsdaten</Header4>
    </v-row>
    <v-row v-if="!fetchError" no-gutters justify="center">
      <CustomAttributesList
        ref="clubList"
        attributable-type="ClubRecord"
        @fetchError="handleFetchError"
        @moved="handleMoved"
      />
    </v-row>
    <ErrorAlert
      :width="450"
      v-else
      title="Fehler beim Laden"
      :message="fetchError"
    />
    <v-row no-gutters style="margin-top: 16px">
      <CustomAttributesCreate
        attributable_type="ClubRecord"
        @created="handleCreation"
      />
    </v-row>
  </div>
</template>

<script lang="ts">
import { defineComponent, Ref, ref } from "vue"
import { mdiClose, mdiDrag, mdiPlus } from "@mdi/js"
import Button from "components/UI/Button.vue"
import {
  CustomAttributeDefinition,
  CustomAttributeDefinitionAttributableTypeEnum,
} from "suus-api"
import CustomAttributesUpdateErrors from "app/modules/custom-attributes/CustomAttributesUpdateErrors.vue"
import CustomAttributesList from "app/modules/custom-attributes/CustomAttributesList.vue"
import Header4 from "app/ui-primitives/header/Header4.vue"
import CustomAttributesCreate from "app/modules/custom-attributes/CustomAttributesCreateDialog.vue"
import ErrorAlert from "app/ui-primitives/alerts/ErrorAlert.vue"
import ErrorSnackbar from "app/ui-primitives/snackbars/ErrorSnackbar.vue"
import SuccessSnackbar from "app/ui-primitives/snackbars/SuccessSnackbar.vue"

export default defineComponent({
  name: "CustomAttributesManagement",
  components: {
    SuccessSnackbar,
    ErrorSnackbar,
    ErrorAlert,
    CustomAttributesCreate,
    Header4,
    CustomAttributesList,
    CustomAttributesUpdateErrors,
    Button,
  },
  setup() {
    const fetchError: Ref<string | null> = ref(null)
    const handleFetchError = (reset?: boolean) => {
      if (reset) {
        fetchError.value = null
      } else {
        fetchError.value =
          "Beim Laden der Feldes ist ein Fehler aufgetreten. Versuche die Seite neu zu laden."
      }
    }

    const personalList: Ref<InstanceType<typeof CustomAttributesList>> =
      ref(null)
    const clubList: Ref<InstanceType<typeof CustomAttributesList>> = ref(null)

    const handleCreation = async (
      customAttribute: CustomAttributeDefinition
    ) => {
      if (customAttribute.attributable_type === "PersonalRecord") {
        personalList.value?.addAttribute(customAttribute)
      } else {
        clubList.value?.addAttribute(customAttribute)
      }
    }

    const handleMoved = async ({
      movedAttribute,
      targetList,
    }: {
      movedAttribute: CustomAttributeDefinition
      targetList: CustomAttributeDefinitionAttributableTypeEnum
    }) => {
      if (targetList === "PersonalRecord") {
        personalList.value?.addAttribute(movedAttribute)
      } else {
        clubList.value?.addAttribute(movedAttribute)
      }
    }

    return {
      mdiDrag,
      mdiPlus,
      handleCreation,
      handleMoved,
      mdiClose,
      handleFetchError,
      fetchError,
      personalList,
      clubList,
    }
  },
})
</script>
